import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoiceKsefStatus } from '../../enums';
import { InvoiceKsefStatusPipe } from '../../pipes';

@Component({
  selector: 'app-invoice-ksef-status',
  imports: [CommonModule, InvoiceKsefStatusPipe],
  templateUrl: './invoice-ksef-status.component.html',
  styleUrl: './invoice-ksef-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceKsefStatusComponent {
  public readonly status = input.required<InvoiceKsefStatus>();

  protected readonly cssClass = computed(() => {
    switch (this.status()) {
      case InvoiceKsefStatus.Pending:
        return 'text-amber-600';

      case InvoiceKsefStatus.Sent:
        return 'text-sky-700';

      case InvoiceKsefStatus.Success:
        return 'text-emerald-600';

      case InvoiceKsefStatus.Error:
        return 'text-red-600';

      default:
        return '';
    }
  });
}
